import { Box } from '@mui/material';
import { ColumnsVisibilityProps } from './columnsVisibility.types';
import ColumnsVisibilityConfig from './components/ColumnsVisibilityConfig/ColumnsVisibilityConfig';
import ColumnsVisibilityFooter from './components/ColumnsVisibilityFooter/ColumnsVisibilityFooter';
import ColumnsVisibilityList from './components/ColumnsVisibilityList/ColumnsVisibilityList';
import ColumnsVisibilityTabs from './components/ColumnsVisibilityTabs/ColumnsVisibilityTabs';
import useColumnsVisibility from './hooks/useColumnsVisibility';

const ColumnsVisibility = ({
  columns,
  list,
  onClose,
  canRestoreToDefaultColumns,
  tabsSlot,
  configs,
}: ColumnsVisibilityProps) => {
  const {
    internalColumns,
    toggleColumn,
    restoreToDefault,
    saveAndApply,
    canSaveColumns,
    canRestoreToDefaultColumns: resolvedCanRestore,
    isSavingColumns,
  } = useColumnsVisibility({ list, columns, onClose, canRestoreToDefaultColumns });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <ColumnsVisibilityTabs tabsSlot={tabsSlot} />
      <ColumnsVisibilityConfig configs={configs} />
      <ColumnsVisibilityList columns={internalColumns} onToggle={toggleColumn} />
      <ColumnsVisibilityFooter
        applyConfig={{
          onApply: saveAndApply,
          canApply: canSaveColumns,
          isApplying: isSavingColumns,
        }}
        restoreConfig={{ onRestore: restoreToDefault, canRestore: resolvedCanRestore }}
      />
    </Box>
  );
};

export default ColumnsVisibility;
